import { Fragment } from 'react'

/**
 * Текст модели с минимальной разметкой.
 *
 * Астрологический разбор длинный — по абзацу на светило, — и без выделенных
 * названий читается сплошной стеной. Просить модель писать совсем без разметки
 * бесполезно: она всё равно ставит `**Марс**`, и человек видит звёздочки.
 * Поэтому разметку мы разрешаем ровно одну — жирный — и рисуем сами.
 *
 * Никакого markdown-разбора и тем более `dangerouslySetInnerHTML`: текст
 * приходит от модели, и вставлять его как HTML нельзя.
 */
export function RichText({ text, style }: { text: string; style?: React.CSSProperties }) {
  const paragraphs = text
    .split(/\n{2,}/)
    .map((p) => p.trim())
    .filter(Boolean)

  return (
    <div style={style}>
      {paragraphs.map((p, i) => (
        <p
          key={i}
          className="prose"
          style={{ margin: i === 0 ? '0 0 12px' : '0 0 12px', whiteSpace: 'pre-line' }}
        >
          {bold(p)}
        </p>
      ))}
    </div>
  )
}

/** Разбирает `**жирный**` — единственная разметка, которую мы поддерживаем. */
function bold(text: string) {
  const parts = text.split(/\*\*(.+?)\*\*/g)
  return parts.map((part, i) =>
    // Нечётные куски — то, что было внутри звёздочек.
    i % 2 === 1 ? (
      <strong key={i} style={{ color: 'var(--ink)', fontWeight: 700 }}>
        {part}
      </strong>
    ) : (
      <Fragment key={i}>{part}</Fragment>
    ),
  )
}
